import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NavParams } from '@ionic/angular';
import {
  faCheck,
  faEnvelope,
  faLink,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { Account, Post } from '@jaimo-solutions-gmbh/platform-services-module';

const wdw = window as any;
const qrCode = wdw.QRCode;

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss'],
})
export class ShareComponent implements OnInit {
  @ViewChild('linkInput') linkInput: ElementRef;

  data: Account | Post;
  title?: string;
  body?: string;
  name?: string;

  mailIcon = faEnvelope;
  whatsappIcon = faWhatsapp;
  facebookLogo = faFacebook;
  closeIcon = faTimes;
  checkmarkIcon = faCheck;
  linkIcon = faLink;

  copied;

  constructor(navParams: NavParams) {
    this.data = navParams.get('data');
  }

  ngOnInit() {
    this.generateQRCode();

    if (this.data instanceof Post) {
      this.name = this.data.source.accountSource.name;
      this.title = this.data.title ?? this.data.source.accountSource.name;
      this.body = 'Sieh dir diesen Beitrag von ' + this.name + ' auf Stage an!';
    } else {
      this.name = this.data.name;
      this.title = this.name + ' auf Stage';
      this.body = 'Sieh dir das Profil von ' + this.name + ' auf Stage an!';
    }
  }

  ngAfterViewInit() {
    this.registerClickEvent();
  }

  registerClickEvent() {
    const input = this.linkInput.nativeElement;

    input?.addEventListener('click', () => {
      input.select();
    });
  }

  shareVia(type) {
    let win;
    if (type === 'whatsapp') {
      win = window.open(
        'https://api.whatsapp.com/send?text=' +
          encodeURIComponent(this.body + '\n\n' + this.getURL()),
        '_blank'
      );
      win.focus();
    } else {
      const subject = encodeURIComponent(this.title);
      const body = this.body + ' %0D%0A%0D%0A' + this.getURL();
      win = window.location.href =
        'mailto:?subject=' + subject + '&body=' + body;
    }
  }

  getURL() {
    return (
      location.origin +
      '/' +
      (this.data instanceof Account
        ? this.data.handle
        : this.data.source.accountSource.handle + '/' + this.data.uniqueShortId)
    );
  }

  copy() {
    if (this.copied) return;

    const input = this.linkInput.nativeElement;
    navigator.clipboard.writeText(input.value).then(() => {
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 3500);
    });
  }

  generateQRCode() {
    const prefersDark = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches;
    new qrCode('qr-code', {
      text: this.getURL(),
      width: 96,
      height: 96,
      colorDark: prefersDark ? '#ffffff' : '#1a1b1d',
      colorLight: prefersDark ? '#1a1b1d' : '#ffffff',
      correctLevel: qrCode.CorrectLevel.H,
    });
  }
}
